// views/auth/register.js  (AR) — ver la nota de login.js sobre la estructura.
export const register_i18n = {
  alts: { banner: "خلفية التسجيل", brand: "WA Checkin", footerLogo: "WA Checkin" },
  aria: { toggleReferral: "تفعيل أو تعطيل رمز الإحالة", togglePassword: "إظهار أو إخفاء كلمة المرور" },
  texts: {
    inviteTitle: "تهانينا!",
    inviteText: "دعاك {name} إلى WACheckin: تحصل على خصم {percent}% خلال أول {months} أشهر.",
    inviteApplied: "مُطبَّق من رابط الدعوة الخاص بك.",
    panelKicker: "WACHECKIN · 2026",
    panelCta: "اكتشف WACheckin",
    langLabel: "اللغة",
    panelTitle: "اضبطه مرة واحدة. والباقي يمشي وحده.",
    panelDesc:
      "رابط تسجيل الوصول، ورسالة الترحيب، والمفاتيح، وبلاغ السلطات تخرج دون أن تتذكّرها.",
    title: "أنشئ حسابك",
    infoTitle: "سجّل في دقائق",
    infoDesc: "أكمل بياناتك وابدأ بأتمتة تسجيل الوصول والتواصل مع ضيوفك.",
    referralHint: "فعّله فقط إذا أُعطي لك رمز.",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
  },
  labels: {
    inviteCode: "رمز الدعوة",
    name: "الاسم",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    phone: "الهاتف",
    referralCode: "رمز الإحالة",
  },
  placeholders: {
    name: "أدخل اسمك",
    email: "أدخل بريدك الإلكتروني",
    password: "أنشئ كلمة مرور",
    referralCode: "الرمز",
  },
  buttons: { submit: "إنشاء حساب", submitting: "جارٍ إنشاء الحساب...", signIn: "تسجيل الدخول" },
  validation: { phoneRequired: "اكتب رقمك، وليس رمز الدولة فقط.", phoneInvalid: "هذا الرقم غير صالح. يرجى مراجعته.", invalidReferralCode: "رمز الشريك غير صالح." },
  toast: {
    signupSuccess: "تم إنشاء الحساب بنجاح!",
    signupError: "تعذّر التسجيل.",
    networkError: "خطأ في الاتصال. حاول مرة أخرى.",
    referralCodeError: "رمز الشريك غير صالح.",
  },
};
